export default {
  MASTER: 'normal',
  SUBACCOUNT: 'operator',
};
